import {field} from "../../../stem-core/state/StoreField.js";
import {EmailSendingStoreObject, MerchantEmailCampaignStatus, MerchantEmailCampaign} from "./MerchantEmailCampaignStore";
import {apiClient, type MerchantScopedRequest} from "../../connection/BlinkApiClient.js";
import {BaseStore, globalStore} from "../../../stem-core/state/Store.js";
import {Merchant} from "../MerchantStore";
import {StemDate} from "../../../stem-core/time/Date";
import {EmailTemplate} from "../EmailTemplateStore";
import type {StoreId} from "../../../stem-core/state/State";

@globalStore
export class MerchantEmailCampaignSegment extends BaseStore("MerchantEmailCampaignSegment", {}, EmailSendingStoreObject) {
    @field("Merchant") merchant: Merchant;
    @field("MerchantEmailCampaign") campaign: MerchantEmailCampaign;
    @field(String) name: string;
    @field("EmailTemplate") template: EmailTemplate;
    @field(Date) createdAt: StemDate;
    @field(MerchantEmailCampaignStatus) status: MerchantEmailCampaignStatus;
    @field(Date) scheduledSendDate: StemDate;
    @field(Object) extraFilters: any; // MerchantAudienceFilters
    @field(Number) maxEmailsToSend: number;

    canBeEdited() {
        return this.status === MerchantEmailCampaignStatus.UNSCHEDULED ||
               this.status === MerchantEmailCampaignStatus.SCHEDULED ||
               this.status === MerchantEmailCampaignStatus.STOPPED;
    }
}

// What MerchantCreateEmailCampaignSegment validates (merchants/deserializers.py:339). The literal "now"
// is the backend's spelling for send immediately. extraFilters is a MerchantUsersFilter there, left open
// here because the only builder answers with null under a TODO
export interface CreateEmailCampaignSegmentRequest extends MerchantScopedRequest {
    campaignId: StoreId;
    templateId: StoreId;
    name: string;
    scheduledSendDate: StemDate | "now";
    extraFilters?: Record<string, any> | null;
    isScheduled?: boolean;
    maxEmailsToSend?: number;
}

export async function apiMerchantCreateEmailCampaignSegment(request: CreateEmailCampaignSegmentRequest) {
    const response = await apiClient.post("/merchant/create_email_campaign_segment/", request);
    return MerchantEmailCampaignSegment.loadObject(response);
}

// What MerchantEditEmailCampaignSegment validates (merchants/deserializers.py:349). Sent with allowNulls,
// so the optionals below clear the field when they go up as null
export interface EditEmailCampaignSegmentRequest extends MerchantScopedRequest {
    emailCampaignSegmentId: StoreId;
    templateId?: StoreId;
    name?: string;
    extraFilters?: Record<string, any> | null;
    maxEmailsToSend?: number | null;
    isScheduled?: boolean;
    scheduledSendDate?: StemDate | "now" | null;
}

export async function apiMerchantEditEmailCampaignSegment(request: EditEmailCampaignSegmentRequest) {
    return await apiClient.post("/merchant/edit_email_campaign_segment", request, {allowNulls: true});
}

// What MerchantStopEmailCampaignSegment validates (merchants/deserializers.py:359)
export interface StopEmailCampaignSegmentRequest extends MerchantScopedRequest {
    emailCampaignSegmentId: StoreId;
}

export async function apiMerchantStopEmailCampaignSegment(request: StopEmailCampaignSegmentRequest) {
    return await apiClient.post("/merchant/stop_email_campaign_segment", request);
}